<template>
     <div class="search_wrap">
            <div class="search_wrap box" :style="'min-height:'+screenHeight*0.7+'px' ">
                <h2 >公告查询</h2>

        

                <div class='optionitem'>
                    <el-input placeholder="" v-model="inputValue" style="width:100%">
                        <template slot="prepend">公告内容：</template>
                    </el-input>
                </div>

                <div class='optionitem'>
                    <el-input placeholder="" v-model="court" style="width:400px">
                        <span slot="prepend" >  法院:  </span>
                    </el-input>

                    <!-- <el-input placeholder="请输入内容" v-model="input1" style="width:400px">
                        <template slot="prepend">公告类型:</template>
                    </el-input> -->
                    <!-- <div style="width:100px">公告类型：</div> -->
                    <el-tag type="info" size="medium" style="height:100%;line-height:40px;font-size:13px;">公告类型：</el-tag>
                    <el-select   v-model="select_type" slot="prepend"    style="width:350px">
                        <template slot="prepend">公告类型:</template>
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="起诉状、上诉状副本" value="起诉状、上诉状副本"></el-option>
                        <el-option label="开庭传票" value="开庭传票"></el-option>
                        <el-option label="裁判文书" value="裁判文书"></el-option>
                        <el-option label="公示催告" value="公示催告"></el-option>
                        <el-option label="破产文书" value="破产文书"></el-option>


                    </el-select>

                </div>

                <div style='width:70%;margin-top:10px;font-size:10px;'>
                    <div class='notice'>公告内容和法院至少选填一项  *数据来源于人民法院公告网实时信息</div>
                </div>


                <div  style="margin-top:25px">
                    <el-row>
                        <el-button @click="SearchEvent"  :disabled="islock==1" :icon=" islock?'el-icon-loading': 'el-icon-search' "   type="primary" style="width:100px">查询</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 100px;width:100px">清空</el-button>
                
                    </el-row>
                </div>
                 
                
<!-- 
                <div class='optionitem'>   
                    <div class="optionitem item_name">法院:</div>
                    <div style="width:40%;"> 
                        <el-input  min=0 v-model="captcha" @input="inputcode" placeholder="必填"></el-input> 
                    </div> 
                    


                    <div class="optionitem item_name">公告类型:</div>
                    <div style="width:40%;"> 
                        <el-input  min=0 v-model="captcha" @input="inputcode" placeholder="必填"></el-input> 
                    </div> 
               
                </div> -->


                <div class='listwrap'>
                    <div class='result_bar'>
                        为您检索到  {{number}} 个结果
                    </div>
                   <!-- <div v-html="resultList" class="detailTable"></div> -->

                    <el-table
                        :data="resultList"
                        stripe
                        style="width: 100%;margin-top:20px;" @row-click="checkDetail">
                        <!-- <template slot-scope="scope" > -->
                            <el-table-column
                                prop="court"
                                label="公告人"
                                width="240" >
                            <!-- <template slot-scope="scope" @click="checkDetail(scope.$index, scope.row)"> </template>   -->

                            </el-table-column>
                            <el-table-column
                            prop="tosendPeople"
                            label="当事人"
                            width="500">
                            <!-- <template slot-scope="scope" @click="checkDetail(scope.$index, scope.row)"> </template>  -->
                            </el-table-column>
                            <el-table-column
                            prop="noticeType"
                            label="公告类型"
                            width="200" >
                            <!-- <template slot-scope="scope" @click="checkDetail(scope.$index, scope.row)"> </template>  -->
                            </el-table-column>
                            <el-table-column
                            prop="publishDate"
                            label="发布时间"
                            width="200">
                            <!-- <template slot-scope="scope" @click="checkDetail(scope.$index, scope.row)"> </template>  -->
                            </el-table-column>
                        <!-- </template>  -->
                    </el-table>



                </div>
    


            </div>

            <div class="bottom">
                <div class="bottom left">
                    <!-- *数据来源于工信部域名信息备案网站 -->
                </div>
                <div class="bottom right">
                    <!-- <Pages :pageTotal="number"  @ChangePage="ChangeListPage" ></Pages> -->


                        <el-pagination
                            @current-change="ChangeListPage"
                            :current-page.sync="currentPage_sync"
                            :page-size="15"
                            layout="prev, pager, next, jumper"
                            :total="number">
                        </el-pagination>





                    <!-- @ChangePage="ChangeListPage" -->

                </div>
                <!-- <a href="javascript:void(0)" @click="open_blank"></a> -->

            </div>



            <el-dialog title="详情" :visible.sync="dialogFormVisible">
                <div class='wrap' >
                
                    <div class='title'>
                        {{dialogData.noticeType}}

                    </div>

                    <div class='tosendPeople'>
                    当事人： {{dialogData.tosendPeople}}
                    </div>

                    <div class='content'>
                        {{dialogData.noticeContent}}
                    </div>
                    <div class='tail' style='margin-top:60rpx'><text style='float:right'>{{dialogData.court}}</text> </div>
                    <div class='tail'><text style='float:right'>刊登日期：{{dialogData.publishDate}}</text> </div>
                    <div class='tail'><text style='float:right'>刊登版面：{{dialogData.publishPage}}</text> </div>



                </div>

            </el-dialog>

   
          

        </div>
</template>

<script>
import Pages from '../Pages.vue'

import { IncUseNumber } from '@/assets/js/cal/cal';  

// function getNum() {
//     var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
//         'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
//         'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
//         'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
//         'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
//         'x', 'y', 'z'];
//     var nums = "";
//     for (var i = 0; i < 32; i++) {
//         var id = parseInt(Math.random() * 61);
//         nums += chars[id];
//     }
//     return nums;
// }

export default {
		name: 'announce',
		// props: {
		// 	pageId: String
        // },
        components: {
            Pages
        },
        created(){

            // var that=this
            this.GetList()
            
            // var data= { 
            //     whattodo: 'announce_index',
            // }
            // const loading = this.$loading({
            // lock: true,
            // text: 'Loading',
            // spinner: 'el-icon-loading',
            // background: 'rgba(0, 0, 0, 0.7)'
            // });
            // this.axios.post('https://api.lawtip.cn',data
            // ).then(function (res) {

            //     window.console.log(res)
            //     if(res.status==200){
            //         let result=res.data
            //         that.resultList=result.data.data,
            //         that.cookies=result.cookies
            //         window.console.log("that.cookies:",that.cookies)


            //     }
            //     loading.close();
                
            // }).catch(function (error) {
            //     window.console.log(error);
            //     loading.close();
    
            // });



        },
        mounted: function () {
            window.console.log('domain created')
            IncUseNumber('announce')
            // if(this.$root.islogin==false){
            //     const h = this.$createElement;
            //     this.$notify({
            //         title: '注意',
            //         message: h('i', { style: 'color: teal'}, 'Hi，本功能需要登录后才可以使用哟')
            //     });
            // }

            
          

        },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,

                // placeholder:'输入案件名称、案号、律师等进行查询',
                select_type:'全部',
                placeholder:'如“www.lawtip.cn”,请只填写 "lawtip.cn" ',
                inputValue:'',//输入框内容
                court:'',
                currentPage_sync:1,
                search_type:'1',
                // captcha_url:'',
                number:0,
                page:1,
                // openid:getNum(),
                // para:'',
                // captcha:'',
                resultList:[],
                cookies:'',
                // notice:'',
                // captcha_verify:'no',
                tableData:[],
                sumList:{},
                para:{"page": '' ,"content": '',"court":  '' ,"type": '' },
                dialogFormVisible:false,
                dialogData:{},
                islock:0,
     
              
            }
        },
        methods:{
            bindPickerChange(e){
                this.index=e.detail.value;
            },
            resetEvent(){
               this.inputValue=''
               this.court=''
            },
          
            SearchEvent(){
                var that=this
                // if(this.inputValue.length<2 && this.court.length<2){
                //     this.$message({
                //         message: '公告内容和法院至少填一项，不少于两字',
                //         type: 'warning'
                //     });
                //     return

                // }
                var para={"page":1,"content":this.inputValue,"court":this.court,"type":this.select_type}
                this.para=para
                this.page=1
                this.currentPage_sync=1
                this.GetList()

                // var data= { 
                //     whattodo: 'announce_search',
                //     para: para,
                //     cookies: that.cookies,



                // }
                // const loading = this.$loading({
                // lock: true,
                // text: 'Loading',
                // spinner: 'el-icon-loading',
                // background: 'rgba(0, 0, 0, 0.7)'
                // });



                // this.axios.post('http://test.lawtip.cn',data
                // ).then(function (res) {
                //     window.console.log(res)
                //     if(res.status==200){
                //         var result = res.data
                //         that.cookies=result.cookies
                //         that.resultList=result.data.data

                //         that.number=result.data.iTotalDisplayRecords
                //         that.sumList={1:result.data.data}
                   
                
                //     }
                //     loading.close();
    
                    
                // }).catch(function (error) {
                //     window.console.log(error);
                //     loading.close();
                // });






            },

            GetList(){

                var that=this
                // if(this.inputValue.length<2 && this.court.length<2){
                //     this.$message({
                //         message: '公告内容和法院至少填一项，不少于两字',
                //         type: 'warning'
                //     });
                //     return

                // }
                // var para={"page":this.page,"content":this.inputValue,"court":this.court,"type":this.select_type}
                // this.para=para
                var para=this.para
                var data= { 
                    // whattodo: 'announce_search',
                    // para: para,
                    // cookies: that.cookies,

                    whattodo: 'announce_search',
                    type:para['type'],
                    court:para['court'],
                    content:para['content'],
                    page:this.page

                }
                // const loading = this.$loading({
                // lock: true,
                // text: 'Loading',
                // spinner: 'el-icon-loading',
                // background: 'rgba(0, 0, 0, 0.7)'
                // });


                that.islock=1
                this.axios.post(this.$root.rootUrl ,data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        var result = res.data
                        if(result.status=='badgate'){
                     
                            that.$notify.info({
                                title: '消息',
                                message: 'Hi，本功能需要登录后才可以使用哟'
                            });

                        }else if(result.status=='ok'){
                            that.cookies=result.cookies
                            that.resultList=result.data.data

                            that.number=result.data.iTotalDisplayRecords
                            that.sumList={1:result.data.data}
                        }


                
                    }
                    // loading.close();
                    that.islock=0
    
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                    that.islock=0
                });

                
            },




            ChangeListPage(page){
                var that=this
                this.page=page
                // var _page=page.toString()
                // window.console.log('_page:',_page);
                window.console.log('sumList:',that.sumList);

                if(that.sumList[page]){
                    window.console.log('this page exist');
                    that.resultList=that.sumList[page]
                    return
                }else{

                    that.para['page']=page
                    that.GetList()

                    // var data= { 
                    //     whattodo: 'announce_search',
                    //     para:that.para,
                    //     cookies: that.cookies
                    // }
                    // const loading = this.$loading({
                    // lock: true,
                    // text: 'Loading',
                    // spinner: 'el-icon-loading',
                    // background: 'rgba(0, 0, 0, 0.7)'
                    // });

                    // this.axios.post('https://api.lawtip.cn',data
                    // ).then(function (res) {

                    //     window.console.log(res)
                    //     if(res.status==200){
                    //         let result = res.data
                    //         that.cookies=result.cookies
                    //         that.resultList=result.data.data
                    //         that.sumList[page]=result.data.data
                    //     }
                    //     loading.close();
                    
                        
                    // }).catch(function (error) {
                    //     loading.close();
                    //     window.console.log(error);
                    // });



                }



            },

            checkDetail(val){  //index, row
                window.console.log('check detail:',val)
                // window.console.log("index:",index)
                // window.console.log("row:",row)
                this.dialogFormVisible =true
                this.dialogData=val
            
            
            
           



            }
















        },


           
            


            
        

       


    }
</script>

<style scoped>
    .el-select .el-input {
        width: 130px;
    }
    .el-input-group__prepend {
        background-color: #fff;
        
    }  
    .input-with-select {
        background-color: #fff;
        width:50%;
        height: 50px;
        border-radius: 5px;
    }

    .search_wrap{
        /* width:96%; */
        min-height: 94%;
        /* padding: 15px; */
        display: flex;
        flex-direction: column;
        /* flex-wrap: wrap; */
        /* line-height: 40px; */
        /* border:1px solid #c41cc4; */
        margin-left: auto;
        margin-right: auto;
        padding: 15px;
    }


    .search_wrap.box{
        /* padding: 20px; */
        width:96%;
        min-height:500px;
        /* min-height: 99%; */
        display: flex;
        flex-direction: column;
        /* border:1px solid #bb14a5; */
        /* border:2px solid #51869c; */
        border-radius: 20px;
        /* margin: auto; */
        /* margin-top:10px; */
        align-items: center;

        margin-left: auto;
        margin-right:auto;
    }

    .inputbox{
       
        width:70%;
       
    
        height: 50px;
        border-radius: 5px;
        
        /* top:260px; 
        position: absolute; */
        

    }

    
.caseType {
    margin-top:10px;
    /* width:750px; */
    width:95%;
    height: 80px;
    text-align: center;

    /* height: 40px; */
    vertical-align: center;
    /* top:340px;
    position: absolute; */
    /* margin-left: 60px; */

    /* border:1px solid #50b66f; */
}


.listwrap{
    width:95%;
    min-height:200px ;
    /* border-top:1.5px solid #37474f;  */

       /* width:95%; */
    margin-top:35px;
    padding-top:15px;
    margin-left: auto;
    margin-right:auto;
    display: flex;
    flex-direction: column;
}

.result_bar{
  width: 99.5%;
  height: 28px;
  font-size:16px;
  line-height: 28px;
  /* background-color: #c2bfbf; */
  background: #37474f;
  color: #fff;
  padding-left: 10px;
  overflow: hidden;
}

 
 
 


.bottom{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 30px;
    line-height: 30px;
    margin-top:4px;
    /* border:1px solid #50b66f;  */
    font-size:13px;
}
.bottom.left{
    width:65%;
    /* border:1px solid #953ba7;  */
    padding-left: 14px;
}
.bottom.right{
    width:35%;
    /* border:1px solid #c9c62e;  */

}




 
.optionitem{
    height: 40px;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    /* align-items: center; */
    /* border:1px solid #b86262; */
    /* margin-top:20px; */
    width:65%;
    /* margin-left: auto;
    margin-right: auto; */
    
}   



.optionitem.item_name{
    width:20%;
    /* border:1px solid #3d2e2e; */
    margin-top:0;

}

.detailTable{
    text-decoration:none;
    color:black;
}
 

 
.notice{
    float: right;
    font-size:14px;
    margin-top:10px;
    margin-right:10px;

}
 



/* pages/tools/announce/detail.wxss */
.wrap{
  width: 97%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right:auto;
}

.title{
  width:100%;
  height: 60px;
  border-bottom: 1px solid #cccbcb; 
  font-size: 18px;

}
.tosendPeople{
  width:100%;
  min-height: 60px;
  font-weight: bold;
  font-size: 18px;
  margin-top:20px;
}
.content{
  width:100%;
  display: flex;
  min-height: 400px;
  font-size:15px;
  line-height: 25px;

}

.tail{
  float: right;
  height: 60px;
  /* display: flex; */
  margin-top:15px;
  /* border: 1px solid #cccbcb;  */
  width:100%;
}






</style>
